document.addEventListener('DOMContentLoaded', function () {
    const impactGridSections = document.querySelectorAll('[id^="impact-grid-"]');

    impactGridSections.forEach(function (section) {
        initFlipCards(section);
        initEntranceAnimations(section);
        initBarAnimations(section);
        initAutoBoldNumbers(section);
    });
});

/**
 * Auto-bold leading numbers in label text.
 * Scans all elements with [data-auto-bold] and wraps leading number patterns
 * (e.g., "98%", "3x", "92%", "45-day") in <b> tags.
 * @param {HTMLElement} section - The impact grid section element
 */
function initAutoBoldNumbers(section) {
    var labels = section.querySelectorAll('[data-auto-bold]');

    labels.forEach(function (label) {
        var text = label.innerHTML;
        // Match leading number patterns: digits optionally followed by %, x, +, -day, etc.
        var boldedText = text.replace(/^(\d[\d.,]*[%xX+]?(?:-\w+)?)(\s)/, '<b>$1</b>$2');
        if (boldedText !== text) {
            label.innerHTML = boldedText;
        }
    });
}

/**
 * Initialize flip card click and keyboard interactions
 * @param {HTMLElement} section - The impact grid section element
 */
function initFlipCards(section) {
    const flipCards = section.querySelectorAll('[data-flip-card]');

    flipCards.forEach(function (card) {
        // Click handler
        card.addEventListener('click', function () {
            toggleFlip(card);
        });

        // Keyboard handler (Enter and Space)
        card.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                toggleFlip(card);
            }
        });
    });
}

/**
 * Toggle the flip state of a card
 * @param {HTMLElement} card - The flip card element
 */
function toggleFlip(card) {
    const isFlipped = card.classList.toggle('is-flipped');
    card.setAttribute('aria-pressed', isFlipped.toString());
}

/**
 * Initialize entrance animations with IntersectionObserver
 * @param {HTMLElement} section - The impact grid section element
 */
function initEntranceAnimations(section) {
    const animateElements = section.querySelectorAll('.impact-grid__animate');

    if (!animateElements.length) return;

    // Respect reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
        // Show all elements immediately without animation
        animateElements.forEach(function (el) {
            el.classList.add('is-visible');
        });
        return;
    }

    // Use IntersectionObserver for animation triggering
    if ('IntersectionObserver' in window) {
        const observerOptions = {
            root: null,
            rootMargin: '0px 0px -50px 0px',
            threshold: 0.1
        };

        let hasAnimated = false;

        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && !hasAnimated) {
                    hasAnimated = true;

                    // Trigger all card animations
                    animateElements.forEach(function (el) {
                        el.classList.add('is-visible');
                    });

                    // Stop observing after animation triggered
                    observer.disconnect();
                }
            });
        }, observerOptions);

        // Observe the section container
        observer.observe(section);
    } else {
        // Fallback: show all elements immediately
        animateElements.forEach(function (el) {
            el.classList.add('is-visible');
        });
    }
}

/**
 * Initialize bar chart grow animations with IntersectionObserver
 * @param {HTMLElement} section - The impact grid section element
 */
function initBarAnimations(section) {
    var barCharts = section.querySelectorAll('[data-animate-bars]');

    if (!barCharts.length) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
        barCharts.forEach(function (chart) {
            chart.classList.add('is-bar-visible');
        });
        return;
    }

    if ('IntersectionObserver' in window) {
        var barObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-bar-visible');
                    barObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.3 });

        barCharts.forEach(function (chart) {
            barObserver.observe(chart);
        });
    } else {
        barCharts.forEach(function (chart) {
            chart.classList.add('is-bar-visible');
        });
    }
}

/**
 * Theme Editor Support
 * Re-initialize when section is added/updated in theme editor
 */
if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
        if (event.target.querySelector('[id^="impact-grid-"]')) {
            const section = event.target.querySelector('[id^="impact-grid-"]');
            initFlipCards(section);
            initAutoBoldNumbers(section);

            // In theme editor, show animations immediately
            var animateElements = section.querySelectorAll('.impact-grid__animate');
            animateElements.forEach(function (el) {
                el.classList.add('is-visible');
            });

            // Show bar charts immediately in editor
            var barCharts = section.querySelectorAll('[data-animate-bars]');
            barCharts.forEach(function (chart) {
                chart.classList.add('is-bar-visible');
            });
        }
    });
}
